/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import { withRouter } from 'react-router';
import {
    object,
    shape,
    string,
} from 'prop-types';

const baseURL = '/account';
// TODO: My Account's menu need to be store in content stack
const listItem = [
    {
        id: 1,
        label: 'MY PROFILE',
        url: `${baseURL}/profile`,
    },
    {
        id: 2,
        label: 'MY ORDERS',
        url: `${baseURL}/orders`,
    },
    {
        id: 3,
        label: 'RESET PASSWORD',
        url: `${baseURL}/change-password`,
    },
    {
        id: 4,
        label: 'WISHLIST',
        url: `${baseURL}/wishlist`,
    },
];

const styles = (theme) => ({
    headingContainer: {
        display: 'grid',
        justifyContent: 'space-between',
        gridTemplateColumns: 'auto auto',
        '& :first-child': {
            fontWeight: '500 !important',
            fontSize: '2.188rem !important',
            marginBottom: '26px !important',
            fontFamily: 'BebasNeue !important',
        },
        '& :last-child': {
            fontWeight: '700',
            textDecoration: 'underline',
        },
    },
    leftMenus: {
        textDecoration: 'none',
        listStyle: 'none',
        lineHeight: 1.5,
        paddingRight: 12,
        minWidth: 160,
        '& .options-container': {
            display: 'grid',
            maxWidth: '880px',
            marginBottom: '3rem',
            gridTemplateColumns: 'repeat(4, auto)',
            [theme.breakpoints.down('sm')]: {
                gap: '15px',
            },
            '& .option': {
                cursor: 'pointer',
                '& span': {
                    color: '#000',
                    fontSize: '13px',
                    [theme.breakpoints.down('sm')]: {
                        fontSize: '11px',
                    },
                    '&.active': {
                        paddingBottom: '0.2rem',
                        borderBottom: '1px solid #000',
                    },
                },
            },
        },
    },
    logoutLink: {
        color: theme?.palette?.common?.black,
        textDecoration: 'none',
        height: '20px',
    },
});

class AccountMenuPlants extends Component {
    handleListItemClicked = (url) => {
        const { history: { push } } = this.props;
        push(url);
    };

    render() {
        const {
            classes, userProfile, featureFlags, customClass,
        } = this.props;
        const currentUrl = typeof window !== 'undefined' ? window.location.pathname : '/';
        return (
            <>
                <div className={classes.headingContainer}>
                    <span>Hello, {userProfile.firstName}</span>
                    <Link to="/auth/logout" data-test="auth-logout" id="auth-logout-link" name="authLogoutLink" className={classes.logoutLink}>Logout</Link>
                </div>
                <Grid className={`${classes.leftMenus} ${classes[customClass]}`} item>
                    <div className="options-container">
                        {listItem.map((list) => {
                            if (
                                (list.userRole
                            && list.userRole !== userProfile.userRole)
                        || (list.flag
                            && featureFlags[list.flag]
                            && featureFlags[list.flag] === 'N')
                            ) {
                                return '';
                            }
                            return (
                                ((currentUrl === '/account' && list.url === '/account/profile') || (currentUrl === list.url) || (list.regEx?.test(currentUrl)))
                                    ? (
                                        <div className="option" key={list.id}><span className="active">{list.label}</span></div>
                                    )
                                    : (
                                        <div className="option" onClick={() => this.handleListItemClicked(list.url)} key={list.id} role="presentation">
                                            <span>
                                                {list.label}
                                            </span>
                                        </div>
                                    )
                            );
                        })}
                    </div>
                </Grid>
            </>
        );
    }
}

AccountMenuPlants.defaultProps = {
    history: {},
    customClass: '',
};

AccountMenuPlants.propTypes = {
    classes: object.isRequired,
    userProfile: shape({
        userRole: string,
    }).isRequired,
    history: object,
    customClass: string,
    featureFlags: object.isRequired,
};

export default withRouter(withStyles(styles)(AccountMenuPlants));
